__turbopack_context__.v({
  "card": "AnnouncementCard-module-scss-module__JTgWha__card",
  "card__content": "AnnouncementCard-module-scss-module__JTgWha__card__content",
  "card__date": "AnnouncementCard-module-scss-module__JTgWha__card__date",
  "card__headingContainer": "AnnouncementCard-module-scss-module__JTgWha__card__headingContainer",
  "card__image": "AnnouncementCard-module-scss-module__JTgWha__card__image",
  "card__summary": "AnnouncementCard-module-scss-module__JTgWha__card__summary",
  "card__title": "AnnouncementCard-module-scss-module__JTgWha__card__title",
});
